"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const IlcIntl_1 = require("./IlcIntl");
const defaultIntlAdapter_1 = __importDefault(require("./defaultIntlAdapter"));
__exportStar(require("./types"), exports);
__exportStar(require("./GlobalBrowserApi"), exports);
__exportStar(require("./IlcIntl"), exports);
__exportStar(require("./utils/isSpecialUrl"), exports);
/**
 * @name IlcAppSdk
 */
class IlcAppSdk {
    constructor(adapter, options) {
        var _a;
        this.adapter = adapter;
        this.options = options;
        /**
         * Isomorphic method to render 404 page.
         * GLOBAL 404:
         * At SSR in processResponse it sets 404 status code to response.
         * At CSR it triggers global event which ILC listens and renders 404 page.
         *
         * CUSTOM 404:
         * At SSR in processResponse it sets 404 status code and "X-ILC-Override" header to response.
         * At CSR it renders own not found route.
         */
        this.render404 = (withCustomContent) => {
            this.adapter.trigger404Page(withCustomContent);
        };
        if (!this.adapter) {
            throw new Error('Unable to determine adapter properly...');
        }
        this.appId = this.adapter.appId;
        const intlAdapter = this.adapter.intl ? this.adapter.intl : defaultIntlAdapter_1.default;
        this.intl = new IlcIntl_1.IlcIntl(this.appId, intlAdapter, (_a = this.options) === null || _a === void 0 ? void 0 : _a.i18n);
        this.cssBundle = options === null || options === void 0 ? void 0 : options.cssBundle;
    }
    unmount() {
        this.intl.unmount();
    }
}
exports.default = IlcAppSdk;
